import { HiDocumentReport } from 'react-icons/hi';
import { TbReportAnalytics } from 'react-icons/tb';
import { TbReport } from 'react-icons/tb';
import { RiDeleteBin4Fill } from 'react-icons/ri';
import { TbFileReport } from 'react-icons/tb';

const subTiles = [
  {
    sNo: 19,
    link: `/common/breakdownCapaAnalysisFormatsUpload/?documentType=breakdownCapaAnalysisFormatsUpload&heading=BREAKDOWN CAPA & ANALYSIS FORMATS`,
    isLink: true,
    icon: <HiDocumentReport size="5rem" color="#003566" />,
    p: 'Breakdown CAPA & Analysis',
    span: 'Formats',
    isIcon: true,
  },
];

export { subTiles };
